<template>
    <div>
        <button
            type="button"
            class="is-primary p-md rounded-full leading-none"
            @click="$modal.show('delivery-project-table-filter')"
        >
            <font-awesome-icon icon="sliders-h" />
        </button>
        <adaptive-modal
            name="delivery-project-table-filter"
            primary-button-text="Applicera"
            primary-button-class="is-primary"
            :show-hide-button="false"
            @save="applyFilters"
        >
            <div class="flex items-center justify-between mb-xl">
                <h1 class="m-0 text-md">
                    Filtrera
                </h1>
                <button
                    type="button"
                    class="btn is-ghost btn-sm"
                    @click="resetFilters"
                >
                    Rensa filter
                </button>
            </div>
            <form
                ref="form"
                :action="route('admin.delivery-projects.index')"
                method="GET"
            >
                <delivery-project-table-filter-manager-select
                    :options="managerOptions"
                    :initial-manager="get_request_value('manager_id')"
                />
                <delivery-project-table-filter-company-select
                    :options="companyOptions"
                    :initial-company="get_request_value('dig_phase_company_id')"
                    phase="dig"
                    label="grävning"
                />
                <delivery-project-table-filter-company-select
                    :options="companyOptions"
                    :initial-company="get_request_value('installation_phase_company_id')"
                    phase="installation"
                    label="installation"
                />
                <delivery-project-table-filter-company-select
                    :options="companyOptions"
                    :initial-company="get_request_value('activation_phase_company_id')"
                    phase="activation"
                    label="driftsättning"
                />
                <input
                    type="hidden"
                    name="status"
                    :value="status"
                >
            </form>
        </adaptive-modal>
    </div>
</template>

<script>
    import DeliveryProjectTableFilterCompanySelect from './DeliveryProjectTableFilterCompanySelect';
    import DeliveryProjectTableFilterManagerSelect from './DeliveryProjectTableFilterManagerSelect';

    export default {
        components: {
            DeliveryProjectTableFilterManagerSelect,
            DeliveryProjectTableFilterCompanySelect,
        },
        props: {
            managerOptions: {
                type: Object,
                required: true,
            },
            companyOptions: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                status: null,
            };
        },
        mounted() {
            this.status = get_request_value('status');
        },
        methods: {
            applyFilters() {
                this.$refs.form.submit();
            },
            resetFilters() {
                window.location = route('admin.delivery-projects.index', { status: this.status });
            },
        },
    };
</script>
